export const usePersistedStore = defineStore('psc-loterie-persisted', {
  state: () => {
    const state: {
      lastSync: Record<string, Date>,
      showMenu: Ref<boolean>,
    } = {
      lastSync: {},
      showMenu: ref(true),
    }
    return state
  },
  getters: {

  },
  actions: {
    /**
     *
     * @param type
     * @param expiration - 0 = always expires, -1 = never expires
     */
    needSync(type: string, expiration: number = 30 * 60 /* 30min */): boolean {
      // const config = useRuntimeConfig()
      const lastSync = this.lastSync[type] ? new Date(this.lastSync[type]) : undefined

      if (expiration === -1) {
        return false
      }

      if (expiration === 0) {
        return true
      }

      const expirationMillis = expiration * 1000

      const nextSync = new Date()
      nextSync.setTime(nextSync.getTime() - expirationMillis)

      if (!lastSync || lastSync.getTime() < nextSync.getTime()) {
        return true
      }

      return false
    },
    setLastSync(type: string): void {
      this.lastSync[type] = new Date()
    },
    resetLastSync(type: string): void {
      delete this.lastSync[type]
    },
  },
  persist: true,
})
